<template>
    <div>
        <h5 style="padding: 20px">
            Are you sure you want to import your list?
        </h5>
        <!-- <radio :field="field"></radio> -->

        <div class="col-md-12 action-buttons">
            <b-button
                type="button"
                variant="primary"
                :class="loading ? 'disabled' : ''"
                @click="onClick"
            >
                <span class="btn-text">Continue</span>
                <span class="loader"></span>
            </b-button>
            <b-button
                type="reset"
                variant="link"
                :class="loading ? 'disabled' : ''"
                @click="onReset"
            >
                <span class="btn-text">Cancel</span>
                <span class="loader"></span>
            </b-button>
        </div>

        <base-toast></base-toast>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Radio from '@/components/registration/Radio.vue'
export default {
    components: {
        Radio,
    },
    data() {
        return {
            field: {
                // key: 'recievePmdaOption',
                isLocked: true,
                isRequired: true,
                options: [
                    {
                        text: 'yes',
                        value: 'yes',
                    },
                    {
                        text: 'no',
                        value: 'no',
                    },
                ],
                label: ' Are you sure you want to merge your list with IDENFOs black list?',
                title: ' Are you sure you want to merge your list with IDENFOs black list?',
            },
        }
    },
    methods: {
        onClick() {
            // console.log('on click submit')
            this.$emit('response', true)
        },
        onReset() {
            this.$emit('response', false)
        },
    },
    computed: {
        ...mapGetters(['loading']),
    },
}
</script>
